import IocTable from './ioc-table'

export default {
  install: function (Vue) {
    Vue.component(IocTable.name, IocTable)
  }
}
